import { gql } from 'apollo-angular';

export const AwardFragmentDoc = gql`
  fragment Awards on Awards {
    id
    name
    image
    value
    quantity
    category
    reserved
    status
    deletedAt
  }
`;

export const GetAllAwardsDocument = gql`
  query GetAllAwardsGQL{
    getAllAwards{
      ...Awards
    }
  }${AwardFragmentDoc}
`;

export const RemoveAwardFragmentDoc = gql`
  fragment RemoveAwards on RemoveAwards {
    message
  }
`;

export const RemoveAwardDocument = gql`
  mutation RemoveAward($data: RemoveAwardsInput!){
    removeAwards(data: $data){
      ...RemoveAwards
    }
  }${RemoveAwardFragmentDoc}
`;

export const CreateAwardDocument = gql`
  mutation CreateAwards($data: CreateAwardsInput!){
    createAwards(data: $data){
      ...Awards
    }
  }${AwardFragmentDoc}
`;

export const UpdateAwardsDocument = gql`
  mutation UpdateAwards($data: UpdateAwardsInput!){
    updateAwards(data: $data){
      id
    }
  }
`;

export const SearchAwardsDocument = gql`
    query SearchAwards($input: SearchAwardsInput!) {
  searchAwards(data: $input) {
    ...Awards
  }
}${AwardFragmentDoc}`;